
    <dw-form-item [dwFlex]="dwFlex">
      <dw-form-label [dwRequired]="dwRequired"
                     [dwOffset]="dwLabelOffset"
                     [dwOrder]="dwLabelOrder"
                     [dwPull]="dwLabelPull"
                     [dwPush]="dwLabelPush"
                     [dwSpan]="dwLabelSpan"
                     [dwXs]="dwLabelXs"
                     [dwSm]="dwLabelSm"
                     [dwMd]="dwLabelMd"
                     [dwLg]="dwLabelLg"
                     [dwXl]="dwLabelXl"
                     [dwXXl]="dwLabelXXl"
                     *ngIf="titleStr ; else titleTpl">{{titleStr}}
      </dw-form-label>
      <dw-form-control #dwFormControl [dwHasFeedback]="dwHasFeedback"
                       [dwOffset]="dwInputOffset"
                       [dwOrder]="dwInputOrder"
                       [dwPull]="dwInputPull"
                       [dwPush]="dwInputPush"
                       [dwSpan]="dwInputSpan"
                       [dwXs]="dwInputXs"
                       [dwSm]="dwInputSm"
                       [dwMd]="dwInputMd"
                       [dwLg]="dwInputLg"
                       [dwXl]="dwInputXl"
                       [dwXXl]="dwInputXXl"
                       [dwValidateStatus]="dwValidateStatus"
      >
        <ng-content></ng-content>
        <dw-form-explain class="pt-1">
          <span *ngIf="dwTips" class="fx-font-size-12px text-body-tertiary">{{dwTips}}</span>
        </dw-form-explain>
        <dw-form-explain>
          <div *ngFor="let msg of validationMessages">{{ msg.message || (msg.key | translate:msg.params) }}</div>
        </dw-form-explain>
      </dw-form-control>
    </dw-form-item>
  